import { ErrorHandler } from '@src/shared/ui/components/ErrorHandler';
import { Grid } from '@uhg-abyss/web/ui/Grid';
import React from 'react';

import { RecordActivity } from './components/RecordActivity';

/**
 * ExpansionRow
 *
 * Expands a table row on click.
 *
 * @param row
 * @returns {Element}
 * @constructor
 */
export function ExpansionRow({
  row = {
    addedRecords: [],
    removedRecords: [],
  },
}) {
  return (
    <ErrorHandler location="src/widgets/RiskRecords/TrustedValueHistory/components/Table/components/ExpansionRow/ExpansionRow.jsx">
      <Grid css={{ margin: 0 }}>
        <Grid.Col
          span={{
            xs: '100%',
          }}
        >
          <RecordActivity addedRecords={row?.addedRecords || []} removedRecords={row?.removedRecords || []} row={row} />
        </Grid.Col>
      </Grid>
    </ErrorHandler>
  );
}
